<template>
  <div :class="$style.root">
    <Loading :class="$style.loading" v-if="loading" />
    <Button v-on="$listeners" rounded v-bind="$attrs">
      <div :style="svgStyle" v-html="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/arrow-right.svg')"></div>
    </Button>
  </div>
</template>

<script>
import Button from './Button'
import Loading from './Loading'

export default {
  components: {
    Button,
    Loading,
  },
  props: {
    size: {
      type: Number,
      default: 40,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    svgStyle () {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      }
    },
  },
}
</script>

<style lang="scss" module>
.root {
  @apply relative;
  @apply inline-block;
}

.loading {
  @apply absolute;
  top: -100px;
  bottom: -100px;
  left: -100px;
  right: -100px;
  @apply m-auto;
}
</style>
